import formatMuiErrorMessage from "../formatMuiErrorMessage/formatMuiErrorMessage.js";
function capitalize(string) {
  if (typeof string != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage(7));
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export {
  capitalize as default
};
//# sourceMappingURL=capitalize.js.map
